import { css } from '@emotion/core';
import { variables, media, rgba, tokens } from '@domain-group/fe-brary';
var colour = variables.colour,
  font = variables.font;
var colors = tokens.colors;
export var sliderContainer = /*#__PURE__*/css("position:relative;margin:auto;background-color:", colour.white, ";overflow:hidden;");
export var cardContainer = {
  name: "79elbk",
  styles: "position:relative;"
};
export var slider = /*#__PURE__*/css("position:relative;margin:auto;overflow-x:auto;display:flex;align-items:flex-start;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;margin-bottom:-50px;padding-bottom:50px;outline:0;", media('>=desktop'), "{scroll-snap-type:none;}");
export var slide = {
  name: "wtk1aa",
  styles: "position:relative;z-index:0;outline:0;scroll-snap-align:center;"
};
export var emptyCard = {
  name: "nxipmh",
  styles: "min-width:120px;min-height:160px;"
};
export var navButtons = /*#__PURE__*/css("position:absolute;color:", colour.neutral700, ";background-color:", colour.white, ";border-radius:50%;box-shadow:0 1px 2px 0 ", rgba(colour.neutral800, 0.2), ",0 1px 3px 0 ", rgba(colour.neutral800, 0.1), ";border:0;top:50px;left:3px;padding:0;width:30px;height:30px;outline:0;z-index:2;", media('>=desktop'), "{width:40px;height:40px;top:43px;&:hover{box-shadow:0 5px 10px 0 ", rgba(colour.neutral800, 0.15), ",0 3px 6px 0 ", rgba(colour.neutral800, 0.15), ";color:", colour.accent, ";}}");
export var navButtonIcon = /*#__PURE__*/css("width:14px;height:14px;vertical-align:middle;", media('>=desktop'), "{width:24px;height:24px;}");
export var navRight = {
  name: "gho1si",
  styles: "right:8px;left:auto;"
};
export var fadeContainer = /*#__PURE__*/css("position:absolute;top:0;width:20px;background:linear-gradient( to right,", rgba(colour.white, 0), ",", rgba(colour.white, 1), " );height:100%;z-index:1;pointer-events:none;");
export var fadeContainerLeft = /*#__PURE__*/css("left:0;background:linear-gradient( to right,", rgba(colour.white, 1), ",", rgba(colour.white, 0), " );");
export var fadeContainerRight = {
  name: "19zs6va",
  styles: "right:0;"
};
export var onboardingCard = {
  name: "12u8n87",
  styles: "display:inline-block;vertical-align:middle;margin-top:25px;"
};
export var onboardingMessage = /*#__PURE__*/css("margin-bottom:40px;color:", colour.neutral700, ";font-family:", font.bodyFontFamily, ";font-size:", font.bodyFontSize, ";");
export var onboardingMessageMobile = /*#__PURE__*/css("position:relative;margin-bottom:24px;font-family:", font.bodyFontFamily, ";font-size:", font.bodyFontSize, ";line-height:1.25;padding:18px 19px 22px 16px;background-color:", colors.neutral.heavy.default, ";color:", colour.white, ";border-radius:4px;");
export var onboardingMessageClose = /*#__PURE__*/css("position:absolute;top:0;right:0;color:", colour.white, ";border:0;background:none;outline:none;padding:8px;");